const containers = () => document.querySelectorAll('.editable-store-tags');

const open = container => {
    container.classList.add('active');
    container.querySelector('.input-area input[type=text]').focus();
};

const close = container => {
    container.classList.remove('active');
    const input = container.querySelector('.input-area input[type=text]');
    input.value = '';
    filterOptions(container, '');
};

const isOpen = container => container.classList.contains('active');

const navigableItems = container => {
    const options = Array.from(container.querySelectorAll('.dropdown .options li:not(.hidden)'));
    const createOption = container.querySelector('.create-tag-option');

    if (createOption && createOption.style.display !== 'none') options.push(createOption);

    return options;
};

const setFocus = (container, element) => {
    container.querySelector('.dropdown .focus')?.classList.remove('focus');
    element?.classList.add('focus');
    element?.scrollIntoView({block: 'nearest'});
};

const moveFocus = (container, direction) => {
    const items = navigableItems(container);

    if (items.length === 0) return;

    const currentIndex = items.indexOf(container.querySelector('.dropdown .focus'));

    let nextIndex;
    if (currentIndex === -1) {
        nextIndex = direction === 'down' ? 0 : items.length - 1;
    } else {
        nextIndex = direction === 'down'
            ? (currentIndex + 1) % items.length
            : (currentIndex - 1 + items.length) % items.length;
    }

    setFocus(container, items[nextIndex]);
};

const filterOptions = (container, query) => {
    const items = container.querySelectorAll('.dropdown .options li');
    const normalizedQuery = query.toLowerCase().trim();

    items.forEach(li => {
        const name = li.dataset.value.toLowerCase();
        li.classList.toggle('hidden', normalizedQuery !== '' && !name.includes(normalizedQuery));
    });

    const createOption = container.querySelector('.create-tag-option');

    if (createOption) {
        const hasExactMatch = Array.from(items).some(li => li.dataset.value.toLowerCase() === normalizedQuery);

        if (normalizedQuery !== '' && !hasExactMatch) {
            createOption.style.display = '';
            createOption.querySelector('.create-tag-name').textContent = query.trim();
        } else {
            createOption.style.display = 'none';
        }
    }

    const hasContent = navigableItems(container).length > 0 || container.querySelector('.empty-message') !== null;

    container.classList.toggle('has-no-matches', !hasContent);

    if (normalizedQuery === '') {
        container.querySelector('.dropdown .focus')?.classList.remove('focus');
    } else {
        setFocus(container, navigableItems(container)[0] ?? null);
    }

    container.querySelector('.input-area').classList.remove('has-pending-tag');
};

const addTag = (container, name, colorClass) => {
    const select = container.querySelector('select');
    const inputArea = container.querySelector('.input-area');
    const textInput = inputArea.querySelector('input[type=text]');

    let option = select.querySelector(`option[value="${CSS.escape(name)}"]`);

    if (!option) {
        option = document.createElement('option');
        option.value = name;
        select.appendChild(option);
    }

    option.selected = true;
    option.setAttribute('selected', 'selected');

    const label = document.createElement('span');
    label.className = 'store-tag-label';
    label.textContent = name;

    const remove = document.createElement('span');
    remove.className = 'store-tag-remove';
    remove.innerHTML = '<i class="fas fa-xmark"></i>';

    const span = document.createElement('span');
    span.className = `store-tag store-tag--${colorClass}`;
    span.dataset.value = name;
    span.append(label, remove);

    inputArea.insertBefore(span, textInput);

    select.dispatchEvent(new Event('input', {bubbles: true}));
};

const removeTag = (container, tagName) => {
    const select = container.querySelector('select');
    const inputArea = container.querySelector('.input-area');

    const option = select.querySelector(`option[value="${CSS.escape(tagName)}"]`);
    if (option) {
        option.selected = false;
        option.removeAttribute('selected');
    }

    const span = inputArea.querySelector(`.store-tag[data-value="${CSS.escape(tagName)}"]`);
    if (span) span.remove();

    select.dispatchEvent(new Event('input', {bubbles: true}));
};

const deselectOption = (container, name) => {
    const li = container.querySelector(`.dropdown li[data-value="${CSS.escape(name)}"]`);

    if (!li) return;

    li.classList.remove('selected');

    const icon = li.querySelector('i');
    icon.classList.remove('fa-check');
    icon.classList.add('fa-plus');
};

export const removeAllTags = button => {
    const container = button.closest('.editable-store-tags');

    container.querySelectorAll('.input-area .store-tag').forEach(tag => {
        removeTag(container, tag.dataset.value);
        deselectOption(container, tag.dataset.value);
    });

    container.querySelector('.input-area input[type=text]').focus();
};

const toggleOption = (container, li) => {
    const name = li.dataset.value;
    const colorClass = li.dataset.colorClass;
    const icon = li.querySelector('i');

    if (li.classList.contains('selected')) {
        li.classList.remove('selected');
        icon.classList.remove('fa-check');
        icon.classList.add('fa-plus');
        removeTag(container, name);
    } else {
        li.classList.add('selected');
        icon.classList.remove('fa-plus');
        icon.classList.add('fa-check');
        addTag(container, name, colorClass);
    }

    container.querySelector('.input-area input[type=text]').value = '';
    filterOptions(container, '');
    container.querySelector('.input-area input[type=text]').focus();
};

document.addEventListener('click', event => {
    const target = event.target;

    const removeButton = target.closest('.editable-store-tags .input-area .store-tag-remove');
    if (removeButton) {
        const container = removeButton.closest('.editable-store-tags');
        const tag = removeButton.closest('.store-tag');
        const name = tag.dataset.value;

        removeTag(container, name);
        deselectOption(container, name);

        return;
    }

    const li = target.closest('.editable-store-tags .dropdown li');
    if (li) {
        const container = li.closest('.editable-store-tags');
        toggleOption(container, li);
        return;
    }

    const createOption = target.closest('.editable-store-tags .create-tag-option');
    if (createOption) {
        const container = createOption.closest('.editable-store-tags');
        const name = createOption.querySelector('.create-tag-name').textContent;
        addTag(container, name, container.dataset.newTagColor);
        container.querySelector('.input-area input[type=text]').value = '';
        filterOptions(container, '');
        container.querySelector('.input-area input[type=text]').focus();
        return;
    }

    const inputArea = target.closest('.editable-store-tags .input-area');
    if (inputArea) {
        const container = inputArea.closest('.editable-store-tags');
        if (!isOpen(container)) {
            open(container);
        }
        return;
    }

    const submitButton = target.closest('button:not([type="button"]):not([type="reset"])');
    const pendingContainer = submitButton?.closest('form')?.querySelector('.editable-store-tags');

    if (pendingContainer) {
        const pendingInput = pendingContainer.querySelector('.input-area input[type=text]');

        if (pendingInput.value.trim() !== '') {
            event.preventDefault();

            open(pendingContainer);
            setFocus(pendingContainer, navigableItems(pendingContainer)[0] ?? null);
            pendingContainer.querySelector('.input-area').classList.add('has-pending-tag');
            pendingInput.focus();

            return;
        }
    }

    containers().forEach(container => {
        if (isOpen(container)) {
            close(container);
        }
    });
});

document.addEventListener('unsaved:shake', event => {
    containers().forEach(container => {
        if (isOpen(container) && event.target.contains(container)) {
            close(container);
        }
    });
});

document.addEventListener('input', event => {
    const input = event.target;
    if (!input.matches('.editable-store-tags .input-area input[type=text]')) return;

    const container = input.closest('.editable-store-tags');
    filterOptions(container, input.value);
});

document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
        containers().forEach(container => {
            if (isOpen(container)) {
                close(container);
                event.stopImmediatePropagation();
            }
        });

        return;
    }

    const input = event.target.closest('.editable-store-tags .input-area input[type=text]');
    if (!input) return;

    const container = input.closest('.editable-store-tags');

    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();

        if (!isOpen(container)) open(container);

        moveFocus(container, event.key === 'ArrowDown' ? 'down' : 'up');

        return;
    }

    if (event.key === 'Enter') {
        if (!isOpen(container)) return;

        const focused = container.querySelector('.dropdown .focus');
        const createOption = container.querySelector('.create-tag-option');
        const createVisible = createOption !== null && createOption.style.display !== 'none';

        if (!focused && !createVisible) return;

        event.preventDefault();

        if (focused && !focused.classList.contains('create-tag-option')) {
            toggleOption(container, focused);

            return;
        }

        addTag(container, createOption.querySelector('.create-tag-name').textContent, container.dataset.newTagColor);
        input.value = '';
        filterOptions(container, '');
    }
});
